module.exports = __webpack_public_path__ + "img/log.754cfaaa.svg";